const handleDisplayProductView = (boxes, productBoxID, variant) => {
  for (let i = 0; i < boxes.length; i++) {
    if (productBoxID === boxes[i].box_id && boxes[i].variants.includes(variant)) return true;
  }

  return false;
};

export default handleDisplayProductView;
